import AxiosService from '../AxiosService';

const ADMIN_ADDRESSES_ENDPOINT = "/api/v1/admin/addresses"
const DATA_ADDRESSES_ENDPOINT = "/api/v1/data/addresses"
const ASSIGNMENTS_ENDPOINT = "/api/v1/data/assignments"
const STATISTICS_ENDPOINT = "/api/v1/statistics"

export default class AdminService {

  constructor() {
    this.service = new AxiosService();
  }

  getStatistics() {
    return this.service.get(STATISTICS_ENDPOINT);
  }

  getAssignment(id) {
    return this.service.get(ASSIGNMENTS_ENDPOINT + `/${id}`);
  }

  getAssignments() {
    return this.service.get(ASSIGNMENTS_ENDPOINT, {
      params: {
        page: 0,
        size: 1000
      }
    });
  }

  updateAssignment(assignment) {
    return this.service.patch(ASSIGNMENTS_ENDPOINT, assignment);
  }

  removeAssignment(id) {
    return this.service.delete(ASSIGNMENTS_ENDPOINT, {
      params: {
        id: id
      }
    });
  }

  loadAddresses(assignmentIds) {
    return this.service.get(ASSIGNMENTS_ENDPOINT + "/" + assignmentIds + "/addresses")
  }

  getAddresses(query) {
    var queryParam = []
    if (query.filterReady) {
      queryParam.push("status=TO_BE_VERIFIED")
    }
    if (query.pageSize) {
      queryParam.push("size=" + query.pageSize)
    }
    if (query.pageNumber) {
      queryParam.push("page=" + query.pageNumber)
    }

    return this.service.get(ADMIN_ADDRESSES_ENDPOINT + "?" + queryParam.join('&'))
  }

  saveAddresses(formData) {
    return this.service.post(DATA_ADDRESSES_ENDPOINT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

}
